// const BASE_URL = "http://192.168.1.118:8090";
const BASE_URL = "https://wbtechindia.com/apis/masterportallin"
const ytStaticApiData ={
    "kind": "youtube#playlistItemListResponse",
    "etag": "gC2uB-6XNVTMl2ldZzns6L9V9jY",
    "items": [
      {
        "kind": "youtube#playlistItem",
        "etag": "HmPK65Nk85rfBroxXvKHoOkBwrU",
        "id": "UEwtbVd2NVd3aGNqd3BldFVmR2ZHd0FkczVUbjIzREdoMS4xMkVGQjNCMUM1N0RFNEUx",
        "snippet": {
          "publishedAt": "2024-07-04T05:27:40Z",
          "channelId": "UCsNPuQ-JAcw5k_Ci8IGPUIg",
          "title": "Easy Diagnostic - How To Get Tracking Summary",
          "description": "Easy Diagnostic is a smart mobile app that simplifies diagnostic center operations. It helps manage lab technicians, offers real-time tracking, and ensures smooth scheduling. With Easy Diagnostic, customers can enjoy the convenience of doorstep diagnostic services, while centers benefit from improved efficiency and reliability.",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/c15c4sNkLAE/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/c15c4sNkLAE/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/c15c4sNkLAE/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/c15c4sNkLAE/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/c15c4sNkLAE/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "MWB Tech India",
          "playlistId": "PL-mWv5WwhcjwpetUfGfGwAds5Tn23DGh1",
          "position": 0,
          "resourceId": {
            "kind": "youtube#video",
            "videoId": "c15c4sNkLAE"
          },
          "videoOwnerChannelTitle": "MWB Tech India",
          "videoOwnerChannelId": "UCsNPuQ-JAcw5k_Ci8IGPUIg"
        }
      },
      {
        "kind": "youtube#playlistItem",
        "etag": "bIc_h669NWL7OKWrTaLAj7sKbYM",
        "id": "UEwtbVd2NVd3aGNqd3BldFVmR2ZHd0FkczVUbjIzREdoMS4wOTA3OTZBNzVEMTUzOTMy",
        "snippet": {
          "publishedAt": "2024-07-04T05:26:42Z",
          "channelId": "UCsNPuQ-JAcw5k_Ci8IGPUIg",
          "title": "Easy Diagnostic - Live Track Lab Technicians",
          "description": "Easy Diagnostic is a smart mobile app that simplifies diagnostic center operations. It helps manage lab technicians, offers real-time tracking, and ensures smooth scheduling. With Easy Diagnostic, customers can enjoy the convenience of doorstep diagnostic services, while centers benefit from improved efficiency and reliability.",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/ekkoh22woC0/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/ekkoh22woC0/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/ekkoh22woC0/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/ekkoh22woC0/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/ekkoh22woC0/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "MWB Tech India",
          "playlistId": "PL-mWv5WwhcjwpetUfGfGwAds5Tn23DGh1",
          "position": 1,
          "resourceId": {
            "kind": "youtube#video",
            "videoId": "ekkoh22woC0"
          },
          "videoOwnerChannelTitle": "MWB Tech India",
          "videoOwnerChannelId": "UCsNPuQ-JAcw5k_Ci8IGPUIg"
        }
      },
      {
        "kind": "youtube#playlistItem",
        "etag": "pDjIwbpm-5zHymXH-_rUcDgSoZQ",
        "id": "UEwtbVd2NVd3aGNqd3BldFVmR2ZHd0FkczVUbjIzREdoMS41MjE1MkI0OTQ2QzJGNzNG",
        "snippet": {
          "publishedAt": "2024-07-04T05:25:31Z",
          "channelId": "UCsNPuQ-JAcw5k_Ci8IGPUIg",
          "title": "Easy Diagnostic -  How To Assign Customers To Doctor's and Lab Technicians",
          "description": "Easy Diagnostic is a smart mobile app that simplifies diagnostic center operations. It helps manage lab technicians, offers real-time tracking, and ensures smooth scheduling. With Easy Diagnostic, customers can enjoy the convenience of doorstep diagnostic services, while centers benefit from improved efficiency and reliability.",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/8pqe5CJ5xow/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/8pqe5CJ5xow/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/8pqe5CJ5xow/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/8pqe5CJ5xow/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/8pqe5CJ5xow/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "MWB Tech India",
          "playlistId": "PL-mWv5WwhcjwpetUfGfGwAds5Tn23DGh1",
          "position": 2,
          "resourceId": {
            "kind": "youtube#video",
            "videoId": "8pqe5CJ5xow"
          },
          "videoOwnerChannelTitle": "MWB Tech India",
          "videoOwnerChannelId": "UCsNPuQ-JAcw5k_Ci8IGPUIg"
        }
      },
      {
        "kind": "youtube#playlistItem",
        "etag": "wprOUOmv_Rey_bbXFpMEY35m58s",
        "id": "UEwtbVd2NVd3aGNqd3BldFVmR2ZHd0FkczVUbjIzREdoMS4wMTcyMDhGQUE4NTIzM0Y5",
        "snippet": {
          "publishedAt": "2024-07-04T05:23:35Z",
          "channelId": "UCsNPuQ-JAcw5k_Ci8IGPUIg",
          "title": "Easy Diagnostic - How To Add Doctor's and Lab Technicians",
          "description": "Easy Diagnostic is a smart mobile app that simplifies diagnostic center operations. It helps manage lab technicians, offers real-time tracking, and ensures smooth scheduling. With Easy Diagnostic, customers can enjoy the convenience of doorstep diagnostic services, while centers benefit from improved efficiency and reliability.",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/2c3RypB1xXc/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/2c3RypB1xXc/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/2c3RypB1xXc/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/2c3RypB1xXc/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/2c3RypB1xXc/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "MWB Tech India",
          "playlistId": "PL-mWv5WwhcjwpetUfGfGwAds5Tn23DGh1",
          "position": 3,
          "resourceId": {
            "kind": "youtube#video",
            "videoId": "2c3RypB1xXc"
          },
          "videoOwnerChannelTitle": "MWB Tech India",
          "videoOwnerChannelId": "UCsNPuQ-JAcw5k_Ci8IGPUIg"
        }
      },
      {
        "kind": "youtube#playlistItem",
        "etag": "VRQEX9ltfUWSOBNYGAPBG2msHu0",
        "id": "UEwtbVd2NVd3aGNqd3BldFVmR2ZHd0FkczVUbjIzREdoMS4yODlGNEE0NkRGMEEzMEQy",
        "snippet": {
          "publishedAt": "2024-07-04T05:21:47Z",
          "channelId": "UCsNPuQ-JAcw5k_Ci8IGPUIg",
          "title": "Easy Diagnostic - Registration",
          "description": "Easy Diagnostic is a smart mobile app that simplifies diagnostic center operations. It helps manage lab technicians, offers real-time tracking, and ensures smooth scheduling. With Easy Diagnostic, customers can enjoy the convenience of doorstep diagnostic services, while centers benefit from improved efficiency and reliability.",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/uR-QW0PFLNY/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/uR-QW0PFLNY/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/uR-QW0PFLNY/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/uR-QW0PFLNY/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/uR-QW0PFLNY/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "MWB Tech India",
          "playlistId": "PL-mWv5WwhcjwpetUfGfGwAds5Tn23DGh1",
          "position": 4,
          "resourceId": {
            "kind": "youtube#video",
            "videoId": "uR-QW0PFLNY"
          },
          "videoOwnerChannelTitle": "MWB Tech India",
          "videoOwnerChannelId": "UCsNPuQ-JAcw5k_Ci8IGPUIg"
        }
      },
      {
        "kind": "youtube#playlistItem",
        "etag": "R3qeOlh32PeWGafDyYNAIWSDJi4",
        "id": "UEwtbVd2NVd3aGNqd3BldFVmR2ZHd0FkczVUbjIzREdoMS41NkI0NEY2RDEwNTU3Q0M2",
        "snippet": {
          "publishedAt": "2024-05-09T12:37:04Z",
          "channelId": "UCsNPuQ-JAcw5k_Ci8IGPUIg",
          "title": "Easy Diagnostic: Live Tracking and Summary",
          "description": "Easy Diagnostic\" is a mobile application designed to streamline the diagnostic process for both customers and diagnostic centers. With its user-friendly interface, customers can easily schedule appointments and receive accurate diagnoses in a timely manner. For diagnostic centers, the app simplifies administrative tasks by allowing them to efficiently manage lab technicians, assign daily routes, and track technician locations in real-time to ensure prompt service delivery.\n\nThe app provides comprehensive track summaries and detailed reports, empowering diagnostic centers to optimize their operations and provide top-notch service to their customers. With Easy Diagnostic, the diagnostic process becomes seamless, efficient, and ultimately improves the overall healthcare experience for everyone involved.",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/MEsq8mGvxL4/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/MEsq8mGvxL4/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/MEsq8mGvxL4/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/MEsq8mGvxL4/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/MEsq8mGvxL4/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "MWB Tech India",
          "playlistId": "PL-mWv5WwhcjwpetUfGfGwAds5Tn23DGh1",
          "position": 5,
          "resourceId": {
            "kind": "youtube#video",
            "videoId": "MEsq8mGvxL4"
          },
          "videoOwnerChannelTitle": "MWB Tech India",
          "videoOwnerChannelId": "UCsNPuQ-JAcw5k_Ci8IGPUIg"
        }
      }
    ],
    "pageInfo": {
      "totalResults": 6,
      "resultsPerPage": 50
    }
  }
  
export {BASE_URL,ytStaticApiData}